<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :long="true" :is-hidden-menu="true">
            <template #top>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>

                <AppBoxContent
                    class="my-2 mt-[-115px]"
                    width="full"
                    rounded="lg"
                    bg-class-color="bg-white"
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    <div class="text-center pt-20 pb-6">
                        <div class="check-mark">
                            <i class="fa fa-exclamation-triangle text-yellow-600 text-[70px]"></i>
                        </div>
                        <div class="pt-6 pb-10">
                            <h2>{{ storeData.noPayrollTitle || "We couldn't find your recent payroll" }}</h2>
                            <p class="text-[#7B7B7B] mt-4 max-w-2xl mx-auto">{{ storeData.message }}</p>
                        </div>
                        <div class="pt-2">
                            <div class="pb-4"><LinkButton :href="storeData.changeBankUrl" type="orange">Connect a Bank with Pay</LinkButton></div>
                            <p class="text-[#7B7B7B] text-sm max-w-xl mx-auto">
                                Already get paid here? Email a recent paystub to
                                <a :href="'mailto:' + storeData.supportEmail" class="text-[#2b8189] hover:underline">{{ storeData.supportEmail }}</a>
                            </p>
                        </div>
                    </div>
                </AppBoxContent>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';

export default {
    name: 'RefinanceNoPayroll',
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        AppBoxContent,
        LinkButton,
    },

    data() {
        return {
        }
    },
}
</script>
